import { useReactiveVar } from '@apollo/client'
import { useCallback } from 'react'
import { filtersReactiveVar, resetFilters } from '../PDNStore'

const usePDNFiltersHook = () => {
    const filters = useReactiveVar(filtersReactiveVar)

    const clearFilters = useCallback(() => {
        resetFilters()
    }, [resetFilters])

    return { filters, clearFilters }
}

export default usePDNFiltersHook
